import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tableChange } from '../actions/table.actions';
import { DEFAULT_PAGE_SIZE } from '../constants/table.constants';
import { tableDataSelector } from '../selectors/resources.selectors';

export const useSimpleSearch = (resource, fieldName, searchAll) => {
  if (!resource || !fieldName) {
    throw new Error('useSimpleSearch - `resource` and `fieldName` are required');
  }

  const dispatch = useDispatch();
  const [query, setQuery] = useState('');
  const { config } = useSelector((state) => tableDataSelector(state, { resource }));

  const onSearch = (_e, queryOverride) => {
    dispatch(
      tableChange(resource, {
        ...config,
        [fieldName]: queryOverride || query,
        page: 1,
        size: searchAll ? 999 : config?.size || DEFAULT_PAGE_SIZE
      })
    );
  };

  const onClear = () => {
    setQuery('');
    dispatch(tableChange(resource, { ...config, [fieldName]: '', page: 1 }));
  };

  const onChange = (value) => setQuery(value);

  return {
    query,
    onClear,
    onSearch,
    onChange
  };
};
